/* ==========================================================================
   C13 HEALTH - Predictive search
   Inline header field + anchored dropdown panel (full-screen sheet on mobile).
   Columns: Suggested searches · Editions · Articles & topics
   ========================================================================== */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var MOBILE = function () { return window.matchMedia('(max-width: 989px)').matches; };

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function mark(text, q) {
    var safe = esc(text);
    if (!q) return safe;
    var terms = q.split(/\s+/).filter(function (t) { return t.length > 1; });
    terms.forEach(function (t) {
      var re = new RegExp('(' + t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig');
      safe = safe.replace(re, '<mark>$1</mark>');
    });
    return safe;
  }
  function debounce(fn, wait) {
    var t; return function () {
      var ctx = this, a = arguments;
      clearTimeout(t); t = setTimeout(function () { fn.apply(ctx, a); }, wait);
    };
  }

  /* ---------- icons ---------- */
  var ICON = {
    search: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.6-3.6"/></svg>',
    arrow:  '<svg viewBox="0 0 16 16" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 8h12M9 3l5 5-5 5"/></svg>',
    arrowLg:'<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 12h17M13 5l7 7-7 7"/></svg>',
    book:   '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 6.5C10.5 5 8.5 4.2 4 4.2v14C8.5 18.2 10.5 19 12 20.5c1.5-1.5 3.5-2.3 8-2.3v-14c-4.5 0-6.5.8-8 2.3z"/><path d="M12 6.5v14"/></svg>',
    leaf:   '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 4C9.5 4 4 9 4 15.5c0 1.7.5 3.2 1.3 4.5C8 15 12 12 18 10.5 13 13 9 16.5 7.5 21"/></svg>',
    pen:    '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15.5 3.5l5 5L8 21H3v-5L15.5 3.5z"/><path d="M13.5 5.5l5 5"/></svg>',
    atom:   '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.2" aria-hidden="true"><circle cx="12" cy="12" r="2" fill="currentColor" stroke="none"/><ellipse cx="12" cy="12" rx="10" ry="4.4"/><ellipse cx="12" cy="12" rx="10" ry="4.4" transform="rotate(60 12 12)"/><ellipse cx="12" cy="12" rx="10" ry="4.4" transform="rotate(120 12 12)"/></svg>',
    mic:    '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" aria-hidden="true"><rect x="9" y="2.5" width="6" height="11" rx="3"/><path d="M5 11a7 7 0 0 0 14 0M12 18v3.5"/></svg>',
    flame:  '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linejoin="round" aria-hidden="true"><path d="M12 2.5s5.5 4.7 5.5 10a5.5 5.5 0 0 1-11 0c0-2 1-3.6 1.8-4.6.3 1.2 1.1 2 2 2 1.5 0 1.4-2.3 1.7-7.4z"/></svg>',
    truck:  '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2 7h11v9H2zM13 10h4l3 3v3h-7z"/><circle cx="6" cy="18" r="1.8"/><circle cx="17" cy="18" r="1.8"/></svg>'
  };

  var TOPIC_ICON = {
    'Inflammaging, in short': 'flame', 'Visceral fat': 'atom', 'The ageing immune system': 'atom',
    'The living artery': 'atom', 'The brain under siege': 'atom', 'The muscle bank': 'leaf',
    'The inner ecosystem': 'leaf', 'Sleep, stress and biological time': 'leaf',
    'From plate to physiology': 'leaf', 'From intention to automatic': 'leaf',
    'Pills and promises': 'atom', 'About the author': 'pen', 'Speaking and events': 'mic',
    'The signed first edition': 'pen', 'Shipping and delivery': 'truck', 'Returns': 'truck',
    'Pre-orders': 'book', 'Healthspan assessments': 'leaf', 'Getting in touch': 'pen',
    'Choosing an edition': 'book', 'Your saved list': 'book'
  };

  /* ---------- recents ---------- */
  var RECENT_KEY = 'c13:searches:v1';
  function readRecent() { try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { return []; } }
  function pushRecent(q) {
    if (!q || q.length < 2) return;
    var list = readRecent().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    list.unshift(q);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 6))); } catch (e) {}
  }

  /* ---------- money ---------- */
  function money(cents, format) {
    if (cents == null) return '';
    var n = cents / 100;
    var f = format || (window.C13 && window.C13.moneyFormat) || '£{{amount}}';
    var value = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (/amount_no_decimals/.test(f)) value = Math.round(n).toLocaleString('en-GB');
    return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/g, value);
  }

  /* ---------- format label from a product title ---------- */
  function formatLabel(title) {
    var t = (title || '').toLowerCase();
    if (/signed/.test(t))   return 'Signed & numbered';
    if (/deluxe|illustrat/.test(t)) return 'Illustrated hardcover';
    if (/ebook|e-book|amazon/.test(t)) return 'Digital edition';
    if (/standard|paperback/.test(t)) return 'Paperback';
    return 'Edition';
  }
  function shortTitle(title) {
    return (title || '').replace(/^The Silent Fire\s*[-–—]\s*/i, '');
  }

  /* ==========================================================
     Rotating keyword placeholder
     ========================================================== */
  function initGhost(root) {
    var ghost = $('[data-c13-ghost]', root);
    if (!ghost) return null;
    var wordEl = $('.c13-hsearch__ghost-word', ghost);
    var words = [];
    try { words = JSON.parse(ghost.getAttribute('data-words') || '[]'); } catch (e) {}
    if (!wordEl || !words.length) return ghost;

    if (RM.matches) { wordEl.textContent = words[0]; return ghost; }

    var wi = 0, ci = 0, deleting = false, timer = null;
    function tick() {
      var word = words[wi];
      if (!deleting) {
        ci++;
        wordEl.textContent = word.slice(0, ci);
        if (ci >= word.length) { deleting = true; timer = setTimeout(tick, 1900); return; }
        timer = setTimeout(tick, 62 + Math.random() * 55);
      } else {
        ci--;
        wordEl.textContent = word.slice(0, ci);
        if (ci <= 0) { deleting = false; wi = (wi + 1) % words.length; timer = setTimeout(tick, 320); return; }
        timer = setTimeout(tick, 28);
      }
    }
    ghost.c13Start = function () { if (!timer) tick(); };
    ghost.c13Stop  = function () { clearTimeout(timer); timer = null; wordEl.textContent = ''; };
    ghost.c13Start();
    return ghost;
  }

  /* ==========================================================
     Suggested searches
     ========================================================== */
  function buildSuggestions(q, corpus, intents) {
    var ql = q.toLowerCase();
    var out = [];
    var seen = {};

    function push(text) {
      var k = text.toLowerCase();
      if (seen[k] || !text) return;
      seen[k] = 1; out.push(text);
    }

    /* 1. corpus phrases that contain the query */
    corpus.forEach(function (phrase) {
      if (out.length >= 8) return;
      if (phrase.toLowerCase().indexOf(ql) > -1) push(phrase);
    });

    /* 2. intent titles that match */
    (intents || []).forEach(function (intent) {
      if (out.length >= 8) return;
      (intent.match || []).forEach(function (kw) {
        if (String(kw).toLowerCase().indexOf(ql) > -1) push(intent.title);
      });
    });

    /* 3. generated variants, so there is always somewhere to go */
    if (out.length < 5 && q.length > 2) {
      push(q + ' and ageing');
      push('Understanding ' + q);
      push(q + ' in The Silent Fire');
    }

    return out.slice(0, 6);
  }

  /* ==========================================================
     Topic rows from the intent map
     ========================================================== */
  function buildTopics(q, intents, articles) {
    var ql = q.toLowerCase();
    var scored = [];

    (intents || []).forEach(function (intent) {
      var score = 0;
      (intent.match || []).forEach(function (kw) {
        var k = String(kw).toLowerCase();
        if (ql === k) score += 12;
        else if (ql.indexOf(k) > -1) score += 6;
        else if (k.indexOf(ql) > -1 && ql.length > 2) score += 4;
      });
      if (score > 0) scored.push({ score: score, intent: intent });
    });

    scored.sort(function (a, b) { return b.score - a.score; });

    var rows = scored.slice(0, 3).map(function (s) {
      var link = (s.intent.links && s.intent.links[0]) || { url: '/search?q=' + encodeURIComponent(q) };
      return {
        eyebrow: s.intent.title,
        title: String(s.intent.answer).replace(/<[^>]+>/g, '').split(/(?<=\.)\s/)[0].slice(0, 90),
        url: link.url,
        icon: TOPIC_ICON[s.intent.title] || 'book'
      };
    });

    /* top up with live journal results */
    (articles || []).forEach(function (a) {
      if (rows.length >= 4) return;
      rows.push({ eyebrow: 'Journal', title: a.title, url: a.url, icon: 'book' });
    });

    return rows;
  }

  /* ==========================================================
     Main
     ========================================================== */
  function init() {
    var root = $('[data-c13-search]');
    if (!root) return;
    if (root.dataset.c13Bound) return;
    root.dataset.c13Bound = '1';

    var header  = $('[data-c13-header]');
    var input   = $('[data-c13-search-input]', root);
    var panel   = $('[data-c13-search-panel]', root);
    var form    = $('[data-c13-search-form]', root);
    var clearBt = $('[data-c13-search-clear]', root);
    var escBt   = $('[data-c13-search-esc]', root);
    var live    = $('[data-c13-search-live]', root);
    var ghost   = initGhost(root);

    var intents = [];
    var intentEl = $('[data-c13-intents]', root);
    if (intentEl) { try { intents = JSON.parse(intentEl.textContent); } catch (e) {} }

    var corpus = [];
    try { corpus = JSON.parse(root.getAttribute('data-corpus') || '[]'); } catch (e) {}

    var popular = [];
    try { popular = JSON.parse(root.getAttribute('data-popular') || '[]'); } catch (e) {}

    var moneyFormat = root.getAttribute('data-money-format') || '£{{amount}}';
    var promo = {
      title: root.getAttribute('data-promo-title') || 'Looking for a specific edition?',
      label: root.getAttribute('data-promo-label') || 'Compare all four formats',
      url:   root.getAttribute('data-promo-url') || '/pages/compare-editions',
      image: root.getAttribute('data-promo-image') || ''
    };

    var scrim = $('.c13-sscrim');
    if (!scrim) {
      scrim = document.createElement('div');
      scrim.className = 'c13-sscrim';
      document.body.appendChild(scrim);
    }

    var cache = {}, controller = null, activeIndex = -1, isOpen = false;

    /* ---------- position the panel under the header ---------- */
    function position() {
      if (MOBILE()) return;
      var top = header ? header.getBoundingClientRect().bottom : 100;
      document.documentElement.style.setProperty('--c13-search-top', Math.max(0, top + 8) + 'px');
    }

    /* ---------- open / close ---------- */
    function open() {
      if (isOpen) return;
      isOpen = true;
      position();
      document.documentElement.classList.add('c13-searching');
      root.classList.add('is-active', 'is-open');
      panel.classList.add('is-open');
      scrim.classList.add('is-open');
      if (MOBILE() && window.C13) window.C13.lockScroll(true);
      render();
      setTimeout(function () { input.focus({ preventScroll: true }); }, MOBILE() ? 120 : 0);
    }
    function close() {
      if (!isOpen) return;
      isOpen = false;
      document.documentElement.classList.remove('c13-searching');
      root.classList.remove('is-active', 'is-open');
      panel.classList.remove('is-open');
      scrim.classList.remove('is-open');
      if (MOBILE() && window.C13) window.C13.lockScroll(false);
      activeIndex = -1;
    }

    $$('[data-c13-search-open]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); open(); });
    });
    if (escBt) escBt.addEventListener('click', function () { close(); input.blur(); });
    scrim.addEventListener('click', close);

    input.addEventListener('focus', function () { open(); setGhost(!input.value); });
    input.addEventListener('click', open);

    if (clearBt) {
      clearBt.addEventListener('click', function () {
        input.value = '';
        root.classList.remove('has-value');
        setGhost(true);
        render();
        input.focus();
      });
    }

    document.addEventListener('click', function (e) {
      if (MOBILE()) return;
      if (root.contains(e.target)) return;
      if (e.target.closest && e.target.closest('[data-c13-search-open]')) return;
      close();
    });

    document.addEventListener('keydown', function (e) {
      var typing = /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName) || document.activeElement.isContentEditable;
      if (e.key === 'Escape' && isOpen) { close(); input.blur(); return; }
      if ((e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey)) { e.preventDefault(); open(); }
      else if (e.key === '/' && !typing && !isOpen) { e.preventDefault(); open(); }
    });

    window.addEventListener('resize', position);
    window.addEventListener('scroll', function () { if (isOpen) position(); }, { passive: true });

    function setGhost(show) {
      if (!ghost) return;
      ghost.classList.toggle('is-hidden', !show);
      if (ghost.c13Start && ghost.c13Stop) { show ? ghost.c13Start() : ghost.c13Stop(); }
    }

    /* ---------- fetch ---------- */
    function fetchResults(q) {
      if (cache[q]) { paint(q, cache[q]); return; }
      if (controller) controller.abort();
      controller = ('AbortController' in window) ? new AbortController() : null;

      var url = (window.routes && window.routes.predictive_search_url ? window.routes.predictive_search_url : '/search/suggest') +
        '.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,article,page,collection' +
        '&resources[limit]=5&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,vendor,tag,body';

      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (json) {
          var res = (json && json.resources && json.resources.results) || {};
          var data = {
            products: res.products || [],
            articles: res.articles || [],
            pages: res.pages || [],
            collections: res.collections || []
          };
          cache[q] = data;
          paint(q, data);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          paint(q, { products: [], articles: [], pages: [], collections: [], failed: true });
        });
    }

    /* ---------- renderers ---------- */
    function chipsHtml(list) {
      return list.map(function (t) {
        return '<button type="button" class="c13-chip" data-c13-search-term="' + esc(t) + '">' + esc(t) + '</button>';
      }).join('');
    }

    function suggestionsHtml(items, q) {
      if (!items.length) return '<p class="c13-form-note">No suggestions yet — press Enter to search everything.</p>';
      return '<div class="c13-sugg">' + items.map(function (s) {
        return '<a class="c13-sugg__item" href="/search?q=' + encodeURIComponent(s) + '" data-c13-sugg>' +
          ICON.search +
          '<span>' + mark(s, q) + '</span>' +
          '<span class="c13-sugg__arrow">' + ICON.arrow + '</span>' +
        '</a>';
      }).join('') + '</div>' +
      '<div class="c13-spanel__kbdhint"><kbd>&uarr;</kbd><kbd>&darr;</kbd><span>Navigate</span><kbd>Enter</kbd><span>Select</span></div>';
    }

    function editionsHtml(products, q) {
      if (!products.length) return '<p class="c13-form-note">No editions matched that phrase.</p>';
      return '<div class="c13-eds">' + products.slice(0, 3).map(function (p) {
        var img = p.featured_image && p.featured_image.url
          ? p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2') : '';
        return '<a class="c13-ed" href="' + esc(p.url) + '">' +
          (img ? '<img class="c13-ed__thumb" src="' + esc(img) + '" alt="" width="76" height="101" loading="lazy" decoding="async">' : '<span class="c13-ed__thumb"></span>') +
          '<span>' +
            '<span class="c13-ed__title">' + mark(shortTitle(p.title), q) + '</span>' +
            '<span class="c13-ed__format">' + esc(formatLabel(p.title)) + '</span>' +
            '<span class="c13-ed__cta">View edition ' + ICON.arrow + '</span>' +
            (p.price != null && p.price > 0 ? '<span class="c13-ed__price">' + money(p.price, moneyFormat) + '</span>' : '') +
          '</span>' +
        '</a>';
      }).join('') + '</div>';
    }

    function topicsHtml(rows, q) {
      var html = '';
      if (rows.length) {
        html += '<div class="c13-topics">' + rows.map(function (r) {
          return '<a class="c13-topic" href="' + esc(r.url) + '">' +
            '<span class="c13-topic__icon">' + (ICON[r.icon] || ICON.book) + '</span>' +
            '<span>' +
              '<span class="c13-topic__eyebrow">' + esc(r.eyebrow) + '</span>' +
              '<span class="c13-topic__title">' + mark(r.title, q) + '</span>' +
            '</span>' +
          '</a>';
        }).join('') + '</div>';
      }
      html += '<a class="c13-spromo" href="' + esc(promo.url) + '">' +
        (promo.image ? '<img class="c13-spromo__img" src="' + esc(promo.image) + '" alt="" loading="lazy" decoding="async">' : '') +
        '<span class="c13-spromo__body">' +
          '<span class="c13-spromo__title">' + esc(promo.title) + '</span>' +
          '<span class="c13-spromo__link">' + esc(promo.label) + ' ' + ICON.arrow + '</span>' +
        '</span>' +
      '</a>';
      return html;
    }

    function paint(q, data) {
      var suggestions = buildSuggestions(q, corpus, intents);
      var topics = buildTopics(q, intents, data.articles);
      var total = data.products.length + data.articles.length + data.pages.length + data.collections.length;
      var suggestionCount = total + suggestions.length;

      var chips = popular.length ? popular : ['Ageing', 'Wellbeing', 'Illustrated edition', 'Dr Suresh Chari'];

      panel.innerHTML =
        '<div class="c13-spanel__head">' +
          '<p class="c13-spanel__lead">Search results for &ldquo;' + esc(q) + '&rdquo;</p>' +
          '<p class="c13-spanel__count">' + suggestionCount + ' suggestion' + (suggestionCount === 1 ? '' : 's') + '</p>' +
        '</div>' +
        '<div class="c13-spanel__popular">' +
          '<span class="c13-spanel__poplabel">Popular</span>' + chipsHtml(chips) +
        '</div>' +
        '<div class="c13-spanel__grid">' +
          '<div class="c13-spanel__col"><p class="c13-spanel__title">Suggested searches</p>' + suggestionsHtml(suggestions, q) + '</div>' +
          '<div class="c13-spanel__col"><p class="c13-spanel__title">Editions</p>' + editionsHtml(data.products, q) + '</div>' +
          '<div class="c13-spanel__col"><p class="c13-spanel__title">Articles &amp; topics</p>' + topicsHtml(topics, q) + '</div>' +
        '</div>' +
        '<a class="c13-spanel__foot" href="/search?q=' + encodeURIComponent(q) + '">' +
          '<span class="c13-spanel__footleft">' + ICON.search + 'See all results for &ldquo;' + esc(q) + '&rdquo;</span>' +
          '<span class="c13-spanel__footright">View all ' + total + ' result' + (total === 1 ? '' : 's') + ' ' + ICON.arrowLg + '</span>' +
        '</a>';

      activeIndex = -1;
      if (live) live.textContent = total + (total === 1 ? ' result' : ' results') + ' for ' + q;
    }

    /* ---------- idle (no query) ---------- */
    function renderIdle() {
      var recent = readRecent();
      var chips = popular.length ? popular : ['Ageing', 'Wellbeing', 'Illustrated edition', 'Dr Suresh Chari'];
      var seedTopics = (intents || []).slice(0, 3).map(function (intent) {
        var link = (intent.links && intent.links[0]) || { url: '/pages/the-science' };
        return {
          eyebrow: intent.title,
          title: String(intent.answer).replace(/<[^>]+>/g, '').split(/(?<=\.)\s/)[0].slice(0, 90),
          url: link.url,
          icon: TOPIC_ICON[intent.title] || 'book'
        };
      });

      var seedProducts = [];
      try { seedProducts = JSON.parse(root.getAttribute('data-seed-products') || '[]'); } catch (e) {}

      panel.innerHTML =
        '<div class="c13-spanel__head">' +
          '<p class="c13-spanel__lead">' + esc(root.getAttribute('data-idle-lead') || 'Start typing, or pick a topic') + '</p>' +
        '</div>' +
        '<div class="c13-spanel__popular">' +
          '<span class="c13-spanel__poplabel">Popular</span>' + chipsHtml(chips) +
        '</div>' +
        '<div class="c13-spanel__grid">' +
          '<div class="c13-spanel__col"><p class="c13-spanel__title">' + (recent.length ? 'Recent searches' : 'Try searching for') + '</p>' +
            suggestionsHtml(recent.length ? recent : corpus.slice(0, 5), '') + '</div>' +
          '<div class="c13-spanel__col"><p class="c13-spanel__title">Editions</p>' +
            (seedProducts.length
              ? '<div class="c13-eds">' + seedProducts.slice(0, 3).map(function (p) {
                  return '<a class="c13-ed" href="' + esc(p.url) + '">' +
                    (p.image ? '<img class="c13-ed__thumb" src="' + esc(p.image) + '" alt="" width="76" height="101" loading="lazy" decoding="async">' : '<span class="c13-ed__thumb"></span>') +
                    '<span>' +
                      '<span class="c13-ed__title">' + esc(shortTitle(p.title)) + '</span>' +
                      '<span class="c13-ed__format">' + esc(formatLabel(p.title)) + '</span>' +
                      '<span class="c13-ed__cta">View edition ' + ICON.arrow + '</span>' +
                    '</span>' +
                  '</a>';
                }).join('') + '</div>'
              : '<p class="c13-form-note">Browse every edition of The Silent Fire.</p>') +
          '</div>' +
          '<div class="c13-spanel__col"><p class="c13-spanel__title">Articles &amp; topics</p>' + topicsHtml(seedTopics, '') + '</div>' +
        '</div>' +
        '<a class="c13-spanel__foot" href="/collections/four-beautiful-editions">' +
          '<span class="c13-spanel__footleft">' + ICON.search + 'Browse all four editions</span>' +
          '<span class="c13-spanel__footright">Explore ' + ICON.arrowLg + '</span>' +
        '</a>';
      activeIndex = -1;
    }

    function render() {
      var q = input.value.trim();
      root.classList.toggle('has-value', q.length > 0);
      if (q.length < 2) { renderIdle(); return; }
      fetchResults(q);
    }

    var run = debounce(function () {
      setGhost(input.value.length === 0);
      render();
    }, 200);

    input.addEventListener('input', run);

    /* chips + suggestion clicks */
    panel.addEventListener('click', function (e) {
      var chip = e.target.closest ? e.target.closest('[data-c13-search-term]') : null;
      if (chip) {
        e.preventDefault();
        input.value = chip.getAttribute('data-c13-search-term');
        root.classList.add('has-value');
        setGhost(false);
        render();
        input.focus();
      }
    });

    /* keyboard navigation */
    input.addEventListener('keydown', function (e) {
      var items = $$('.c13-sugg__item, .c13-ed, .c13-topic', panel);
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        if (!items.length) return;
        e.preventDefault();
        items.forEach(function (i) { i.classList.remove('is-active'); });
        activeIndex += (e.key === 'ArrowDown' ? 1 : -1);
        if (activeIndex < 0) activeIndex = items.length - 1;
        if (activeIndex >= items.length) activeIndex = 0;
        items[activeIndex].classList.add('is-active');
        items[activeIndex].scrollIntoView({ block: 'nearest' });
      } else if (e.key === 'Enter') {
        if (activeIndex > -1 && items[activeIndex]) {
          e.preventDefault();
          pushRecent(input.value.trim());
          window.location.href = items[activeIndex].getAttribute('href');
        } else {
          pushRecent(input.value.trim());
        }
      }
    });

    if (form) form.addEventListener('submit', function () { pushRecent(input.value.trim()); });

    position();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else { init(); }

  document.addEventListener('shopify:section:load', function () {
    var r = $('[data-c13-search]');
    if (r) delete r.dataset.c13Bound;
    init();
  });
})();
